{
  "status": {
    "PLANNED": "Planned",
    "READY": "Ready",
    "INVOICED": "Invoiced",
    "CANCELLED": "Cancelled"
  },
  "payment": {
    "UNPAID": "Unpaid",
    "PARTIAL": "Partly paid",
    "PAID": "Paid",
    "OVERDUE": "Overdue"
  },
  "errors": {
    "requestUsed": "These instalments were invoiced by an earlier attempt. Close the sheet and look at the contract's invoices.",
    "someItems": "Some instalments can no longer be invoiced (invoiced meanwhile, cancelled or not ready). Close the sheet and choose again.",
    "changed": "Someone changed this contract in the meantime. The latest is loaded now: check it and try again."
  },
  "salesOff": {
    "title": "Sales is turned off for your company",
    "body": "Instalments become READY on their billing date, but they can't be invoiced until Sales is turned back on."
  },
  "instalments": {
    "title": "Instalments",
    "hint": "Schedule: {{schedule}} · {{timing}}",
    "scheduled": "Scheduled (before VAT)",
    "select": "Select {{label}}",
    "selectAll": "Select every ready instalment",
    "bills": "Bills {{date}}",
    "netAndTax": "{{net}} + VAT {{tax}}",
    "cancelledBecause": "Cancelled: {{reason}}",
    "frozen": "The contract is waiting for approval: its instalments can't change until it is decided.",
    "empty": "No instalments yet. Add one, or rebuild them from the schedule.",
    "emptyCustom": "This contract is billed on a custom schedule: add its instalments by hand.",
    "emptyDraft_one": "Activating the contract makes its instalment from the schedule ({{schedule}}).",
    "emptyDraft_other": "Activating the contract makes its {{n}} instalments from the schedule ({{schedule}}).",
    "emptyDraftNone": "Activating the contract makes its instalments from the schedule.",
    "bulk_one": "{{n}} instalment selected · {{total}}",
    "bulk_other": "{{n}} instalments selected · {{total}}",
    "columns": {
      "select": "Select",
      "label": "Instalment",
      "billingDate": "Billing date",
      "amount": "Amount",
      "tax": "VAT",
      "total": "Total",
      "status": "Status",
      "actions": "Actions"
    }
  },
  "actions": {
    "add": "Add instalment",
    "edit": "Edit",
    "cancel": "Cancel instalment",
    "label": "Actions for {{label}}",
    "invoice": "Invoice",
    "invoiceNamed": "Invoice {{label}}",
    "invoiceMany_one": "Invoice {{n}} instalment",
    "invoiceMany_other": "Invoice {{n}} instalments",
    "rebuild": "Rebuild from the schedule"
  },
  "drawer": {
    "newTitle": "Add an instalment",
    "editTitle": "Edit {{label}}",
    "changed": "Someone changed this instalment since you opened it. Your changes weren't saved; load the latest to see theirs, then make yours again.",
    "loadLatest": "Load the latest",
    "description": "An instalment of {{number}}: it becomes ready to invoice on its billing date.",
    "label": "Label",
    "labelHint": "Printed on the invoice line with the contract number and the period.",
    "labelPlaceholder": "Q1 2027, January 2027",
    "periodStart": "Period from",
    "periodEnd": "Period to",
    "billingDate": "Billing date",
    "billingDateHint": "Ready to invoice from this day.",
    "amount": "Amount before VAT",
    "amountHint": "In OMR, three decimals.",
    "amountRest": "The schedule still lacks {{amount}} of the contract value.",
    "tax": "VAT rate",
    "contractRate": "The contract's rate",
    "contractRateNamed": "The contract's rate: {{rate}}",
    "add": "Add instalment",
    "save": "Save instalment",
    "errors": {
      "label": "Give the instalment a label",
      "amount": "Enter an amount above zero",
      "period": "Choose a date within the contract period",
      "periodEnd": "The period ends before it starts",
      "billingDate": "Choose the billing date",
      "field": "Check this field"
    }
  },
  "cancel": {
    "title": "Cancel {{label}}?",
    "body": "It stays listed, struck through, and leaves the schedule ({{amount}} before VAT). It can't be invoiced afterwards.",
    "reason": "Reason",
    "reasonRequired": "Give a reason",
    "confirm": "Cancel instalment"
  },
  "rebuild": {
    "title": "Rebuild the instalments from the schedule?",
    "body_one": "The instalment not invoiced yet ({{amount}} before VAT) is replaced by instalments made from the schedule ({{schedule}}) for what isn't invoiced.",
    "body_other": "The {{n}} instalments not invoiced yet ({{amount}} before VAT) are replaced by instalments made from the schedule ({{schedule}}) for what isn't invoiced.",
    "none": "Instalments are made from the schedule ({{schedule}}) for what isn't invoiced yet.",
    "unchanged": "Nothing changes: the instalments not yet invoiced already follow the schedule.",
    "makesNone": "No instalment is made: the invoiced ones cover the value.",
    "makes_one": "It makes {{n}} instalment:",
    "makes_other": "It makes {{n}} instalments:",
    "kept": "Invoiced instalments stay as they are.",
    "confirm": "Rebuild"
  },
  "toast": {
    "added": "Instalment {{label}} added",
    "saved": "Instalment {{label}} saved",
    "cancelled": "Instalment {{label}} cancelled",
    "rebuilt_one": "Instalments rebuilt: {{n}} on the schedule",
    "rebuilt_other": "Instalments rebuilt: {{n}} on the schedule"
  },
  "invoices": {
    "title": "Invoices",
    "hint": "The Sales invoices of the contract's instalments, newest first. Payments are collected in Sales.",
    "empty": "No invoices for {{number}} yet.",
    "draft": "Draft",
    "balance": "Balance",
    "columns": {
      "number": "Invoice",
      "date": "Date",
      "status": "Status",
      "total": "Total",
      "paid": "Paid",
      "balance": "Balance"
    }
  },
  "sheet": {
    "title_one": "Invoice {{n}} instalment",
    "title_other": "Invoice {{n}} instalments",
    "description": "One posted Sales invoice per contract, a line per instalment. Check it before you post it.",
    "invoiceDate": "Invoice date",
    "invoiceDateHint": "The due date follows the customer's payment terms.",
    "notes": "Notes",
    "notesHint": "Optional. Printed on each invoice.",
    "previewFailed": "The invoices couldn't be prepared",
    "nothing": "None of these instalments can be invoiced now.",
    "consequence_one": "{{n}} invoice will be posted for {{items}}, {{total}} with VAT.",
    "consequence_other": "{{n}} invoices will be posted for {{items}}, {{total}} with VAT.",
    "refusedTitle_one": "{{n}} instalment is left out",
    "refusedTitle_other": "{{n}} instalments are left out",
    "billTo": "Bill to",
    "reference": "Reference",
    "previewStamp": "Preview",
    "slip": "Invoice for {{number}}",
    "lines": "Lines of the invoice for {{number}}",
    "columns": {
      "description": "Description",
      "net": "Amount"
    },
    "taxLine": "{{rate}} · VAT {{tax}}",
    "noTax": "No VAT",
    "subtotal": "Subtotal",
    "tax": "VAT",
    "total": "Total",
    "posts": "Posting is final: a mistake is corrected by voiding the invoice in Sales.",
    "confirm_one": "Post {{n}} invoice",
    "confirm_other": "Post {{n}} invoices",
    "retry": "Try again",
    "failed": "The invoices weren't posted",
    "salesOffTitle": "Sales is turned off for your company",
    "salesOffBody": "Instalments can't be invoiced until Sales is turned back on.",
    "toast_one": "{{n}} invoice posted",
    "toast_other": "{{n}} invoices posted",
    "toastRepeat_one": "Already posted: {{n}} invoice",
    "toastRepeat_other": "Already posted: {{n}} invoices",
    "doneTitle_one": "{{n}} invoice posted",
    "doneTitle_other": "{{n}} invoices posted",
    "doneBody_one": "{{n}} invoice was posted in Sales, {{total}} with VAT.",
    "doneBody_other": "{{n}} invoices were posted in Sales, {{total}} with VAT.",
    "repeatBody": "These invoices were posted by an earlier attempt of this request; nothing was posted twice.",
    "forContract": "Contract {{number}}",
    "done": "Done",
    "instalments_one": "{{n}} instalment",
    "instalments_other": "{{n}} instalments"
  },
  "preview": {
    "refused": {
      "invoiced": "already invoiced",
      "cancelled": "cancelled",
      "notFound": "no longer exists",
      "notActive": "its contract can't be billed now",
      "notReady": "not ready to invoice yet"
    }
  },
  "queue": {
    "title": "Contract billing",
    "intro": "Instalments whose billing date has come, across every contract. Select them and post their invoices: one per contract.",
    "tableLabel": "Instalments ready to invoice",
    "summary_one": "{{n}} instalment ready to invoice",
    "summary_other": "{{n}} instalments ready to invoice",
    "searchPlaceholder": "Search contract, customer or instalment…",
    "searchLabel": "Search the ready instalments",
    "clearSearch": "Clear the search",
    "clearFilters": "Clear filters",
    "filterCustomer": "Customer",
    "anyCustomer": "Any customer",
    "contractFilter": "Contract",
    "clearContract": "Show every contract",
    "select": "Select {{label}} of {{number}}",
    "selectAll": "Select every instalment on this page",
    "invoice_one": "Invoice {{n}} instalment · {{total}}",
    "invoice_other": "Invoice {{n}} instalments · {{total}}",
    "columns": {
      "contract": "Contract",
      "instalment": "Instalment",
      "billingDate": "Billing date",
      "amount": "Amount",
      "tax": "VAT",
      "total": "Total"
    },
    "empty": {
      "title": "Nothing to invoice",
      "body": "Instalments appear here on their billing date.",
      "filteredTitle": "No ready instalment matches",
      "filteredBody": "Change the search or clear the filters."
    }
  },
  "insights": {
    "title": "Contract insights",
    "intro": "How the maintenance contracts are kept: what needs doing now, planned visits done against due, problem assets, warranty, renewals and, for those who see money, what each contract earns.",
    "issues_one": "{{n}} issue",
    "issues_other": "{{n}} issues",
    "faultJobs_one": "{{n}} fault job",
    "faultJobs_other": "{{n}} fault jobs",
    "attention": {
      "title": "Needs attention",
      "empty": "Nothing needs attention.",
      "renew": "Renew",
      "renewNamed": "Renew {{number}}",
      "kind": {
        "VISIT_OVERDUE": "Late planned visit",
        "RENEWAL_DUE": "Renewal due",
        "BILLING_READY": "Ready to invoice",
        "WARRANTY_EXPIRING": "Warranty ending",
        "PROBLEM_ASSET": "Problem asset"
      },
      "label": {
        "VISIT_OVERDUE_one": "{{job}} at {{site}}: planned visit {{n}} day late",
        "VISIT_OVERDUE_other": "{{job}} at {{site}}: planned visit {{n}} days late",
        "RENEWAL_DUE_one": "{{number}} · {{customer}} ends in {{n}} day, not renewed",
        "RENEWAL_DUE_other": "{{number}} · {{customer}} ends in {{n}} days, not renewed",
        "BILLING_READY_one": "{{number}} · {{customer}}: {{n}} instalment ready to invoice, {{total}}",
        "BILLING_READY_other": "{{number}} · {{customer}}: {{n}} instalments ready to invoice, {{total}}",
        "WARRANTY_EXPIRING_one": "Warranty of {{tag}} at {{site}} ends in {{n}} day",
        "WARRANTY_EXPIRING_other": "Warranty of {{tag}} at {{site}} ends in {{n}} days",
        "PROBLEM_ASSET": "{{tag}} at {{site}} keeps failing"
      },
      "reason": {
        "VISIT_OVERDUE": "{{plan}} · {{number}} · due {{date}}",
        "RENEWAL_DUE": "Ends {{date}}",
        "BILLING_READY": "Ready since {{date}}",
        "WARRANTY_EXPIRING": "Until {{date}} · covered by {{number}}",
        "WARRANTY_EXPIRING_BARE": "Until {{date}}",
        "PROBLEM_ASSET": "{{issues}} and {{faults}} in 90 days · last {{date}}"
      }
    },
    "compliance": {
      "title": "Compliance by contract",
      "hint": "Active contracts, worst first: planned visits done of those due, skipped ones left out.",
      "last12": "Last 12 periods",
      "stripLabel": "{{number}}: the last periods",
      "noPlans": "No planned visits",
      "counts": "{{done}} of {{due}} done · {{skipped}} skipped",
      "empty": "No active contract has planned visits yet."
    },
    "renewals": {
      "title": "Renewals",
      "hint": "Active contracts ending within 90 days.",
      "endsIn_one": "Ends in {{n}} day",
      "endsIn_other": "Ends in {{n}} days",
      "endsToday": "Ends today",
      "notRenewed": "Not renewed",
      "empty": "No contract ends within 90 days."
    },
    "warranty": {
      "title": "Warranty ending",
      "hint": "Covered assets whose warranty ends within 60 days.",
      "daysLeft_one": "{{n}} day left",
      "daysLeft_other": "{{n}} days left",
      "endsToday": "Ends today",
      "empty": "No warranty ends within 60 days."
    },
    "problems": {
      "title": "Problem assets",
      "hint": "Most issues found on checks and fault jobs in the last 90 days.",
      "empty": "No asset had issues or fault jobs in the last 90 days."
    },
    "profit": {
      "title": "Profitability",
      "invoiced": "Invoiced",
      "parts": "Covered parts",
      "margin": "Margin",
      "marginPercent": "Margin %",
      "estimated": "Estimated: covered parts are valued at their average cost. Invoiced is the instalment invoices plus the chargeable invoices of the contract's jobs, before VAT.",
      "empty": "Nothing invoiced on a contract yet."
    },
    "columns": {
      "contract": "Contract",
      "compliance": "Compliance",
      "visits": "Visits",
      "endsIn": "Ends",
      "value": "Value",
      "renewal": "Renewal",
      "asset": "Asset",
      "site": "Site",
      "issues": "Issues",
      "faultJobs": "Fault jobs",
      "last": "Last"
    }
  },
  "strip": {
    "scheduledOf": "Scheduled {{scheduled}} of {{value}}, before VAT",
    "differenceOverBy": "The instalments exceed the contract value by {{amount}}.",
    "differenceShortBy": "The instalments fall short of the contract value by {{amount}}."
  }
}
